import React, {useEffect, useState} from 'react';
import MainLayout from "../../layouts/main";
import HelperService from "../../services/helper-service";
import Section from "../../components/section";
import LocationFilter from "../../components/location-filter";
import {getSearchFilter} from "../../modules/auth-persistor";
import {useGlobalNotificationMessage} from "../../context/message";
import {AppRoutes} from "../../utils/constants";
import SearchFilter from "../../components/search-filter";
import {useTrainerService} from "../../services/trainer-service";
import {Link} from "react-router-dom";
import StarRating from "../../components/star-rating";
import {useFavouritesService} from "../../services/favourites-service";
import ActiveFilters from "../../components/active-filters";
import SearchParamsFilter from "../../components/search-params-filter";
import {useAuth} from "../../context/auth";

export default function SearchTrainers () {

    const defaultPagination = {offset:0, limit: 20, count: 0};
    const [loaded, setLoaded] = useState(false);
    const [trainers, setTrainers] = useState([]);
    const [pagination, setPagination] = useState(defaultPagination);
    const [showLoadMore, setShowLoadMore] = useState(false);

    const favouriteService = useFavouritesService();
    const trainerService = useTrainerService();
    const {addErrorMessage} = useGlobalNotificationMessage();
    const auth = useAuth();

    // const [searchParams] = useSearchParams();
    // const pCategories = searchParams.get('categories');

    useEffect(() => {
        let promises = [
        ];

        let searchFilter = getSearchFilter();
        if (searchFilter){
            promises.push(trainerService.getList(searchFilter));
        }
        Promise.all(promises).then(async ([_trainers = null]) => {
            setTrainers(_trainers?.trainers || []);
            setPagination(_trainers?.pagination || defaultPagination)
            setLoaded(true);
        }).catch(error => {
            HelperService.handleApiErrors(error, addErrorMessage);
        });
    }, []);

    useEffect(() => {
        if (parseInt(pagination?.offset) + parseInt(pagination?.limit) < parseInt(pagination?.count)){
            setShowLoadMore(true);
        } else setShowLoadMore(false);
    }, [pagination]);

    const onFilterChanged = (filter) => {
        HelperService.log(filter);
        //get latest events based on filter
        trainerService.getList(filter).then((res)=>{
            setTrainers(res?.trainers || []);
        }).catch((res)=>{
            addErrorMessage(res);
        })
    }

    function loadMore(){
        const newSearchFilter = Object.assign({}, getSearchFilter(),{offset: parseInt(pagination.offset)+parseInt(pagination.limit)});
        trainerService.getList(newSearchFilter)
            .then((_trainers) => {
                //we make unique check before adding the next set
                let idSet = new Set(trainers.map(t => t.id));
                _trainers.trainers = _trainers.trainers.filter(t => !idSet.has(t.id));

                setTrainers([...trainers, ..._trainers.trainers]);
                setPagination(_trainers.pagination);
            }).catch(error => {
            HelperService.handleApiErrors(error, addErrorMessage);
        });
    }

    const toggleLikeTrainer = function (t){
        if (t.liked){
            favouriteService
                .unlikeTrainer(t.id)
                .then(() => {
                    let newT = Object.assign({}, t, {liked:false});
                    setTrainers([...HelperService.addOrReplaceItemInList(trainers, newT, 'id')]);
                })
                .catch(error => {
                    HelperService.handleApiErrors(error, addErrorMessage);
                });
        } else {
            favouriteService
                .likeTrainers([t.id])
                .then(() => {
                    let newT = Object.assign({}, t, {liked:true});
                    setTrainers([...HelperService.addOrReplaceItemInList(trainers, newT, 'id')]);
                })
                .catch(error => {
                    HelperService.handleApiErrors(error, addErrorMessage);
                });
        }
    }

    const TopTrainerModalCell = function({trainer, ...props}) {
        return (
            <Link to={`${AppRoutes.trainers.path}/${trainer.id}`} className="clickable router-link">
                <div className="card px-3 py-4 mb-4 border-0 hover-cell-effect rounded-3">
                    <div className="d-flex flex-row gap-3">
                        <div className="rounded-circle bg-cover flex-shrink-0"
                             style={{backgroundImage: `url(${trainer.photo})`, width: '90px', height: '90px'}}></div>
                        <div className="px-2 w-100" style={{minWidth: 0}}>
                            <h6 className="mb-1">{trainer.name} {trainer.surname}</h6>
                            <div className="text-secondary fs-7 mb-1">
                                {trainer.classes === 0 && <span>No upcoming classes</span>}
                                {trainer.classes > 0 && <span>Upcoming {trainer.classes} classes</span>}
                            </div>
                            <StarRating rating={trainer.rating} count={trainer.ratingsCount || trainer.reviews} showCount={true} />
                            {trainer.id!==auth.currentUser.id && <button
                                onClick={(e)=>{e.preventDefault(); toggleLikeTrainer(trainer);}}
                                className={`btn btn-sm mt-2 ${trainer.liked ? 'btn-outline-primary' : 'btn-primary'}`}>
                                {trainer.liked ? 'Following' : 'Follow'}
                            </button>}
                        </div>
                    </div>
                </div>
            </Link>
        );
    }

    return (
        <>

            <Section animation={HelperService.getRandomAnimation()} className="position-relative section-padding-first">
                <div className={"container"}>
                    <div className={"row"}>
                        <div className={"col-sm-12 col-md-4 col-lg-6"}>
                            <h1 className="header-stripe-blue">Search trainers</h1>
                            <p>Search for trainers</p>
                        </div>
                        <div className={"col-sm-12 col-md-6 p-4"}>
                            <div className="row px-2 rounded-3 bg-light">
                                <div className="col-sm-12 col-md-8 col-xl-6 py-2 px-0 d-flex flex-wrap">
                                    <LocationFilter onChange={(filter) => onFilterChanged(filter)}/>
                                    <SearchParamsFilter onChange={(filter) => onFilterChanged(filter)}/>
                                </div>
                                <div className="col-sm-12 col-md-4 col-xl-6 py-2 px-0 flex-shrink-1">
                                    <SearchFilter onChange={(filter) => onFilterChanged(filter)}/>
                                </div>
                                <div className={"col-sm-12 px-0"}>
                                    <ActiveFilters onChange={(filter) => onFilterChanged(filter)}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Section>

            {trainers?.length > 0 &&
                <Section animation={HelperService.getRandomAnimation()} className="position-relative section-padding">
                    <div className={"container"}>
                        <div className={"row"}>
                            {trainers.map(t => <div key={t.id} className={'col-sm-6 col-md-4 mb-2'}>
                                <TopTrainerModalCell trainer={t} link={`${AppRoutes.trainers.path}/TID`}/>
                            </div>)}
                            {showLoadMore && <div className="text-center">
                                <button className="btn btn-outline-primary my-2" onClick={() => loadMore()}>Load more trainers</button>
                            </div>}
                        </div>
                    </div>
                </Section>}

            {trainers?.length === 0 &&
                <Section animation={HelperService.getRandomAnimation()} className="position-relative section-padding">
                    <div className={"container"}>
                        <div className={"row"}>
                        <h4>We could not find your fit.</h4>
                            <p>Try changing your filter or location/date settings.</p>
                        </div>
                    </div>
                </Section>}

        </>
    );
}

SearchTrainers.getLayout = function getLayout(page) {
    return (
        <MainLayout>
            {page}
        </MainLayout>
    )
}